import { render } from "./pb-participantstextblock.vue?vue&type=template&id=68163076"
import script from "./pb-participantstextblock.vue?vue&type=script&lang=js"
export * from "./pb-participantstextblock.vue?vue&type=script&lang=js"

import "./pb-participantstextblock.vue?vue&type=style&index=0&id=68163076&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__